<template>
  <LoginLayout class="complete">
    <h1 class="title">パスワード再設定メールをお送りしました</h1>
    <p>ご登録のメールアドレスに、パスワード再設定メールをお送りいたしました。</p>
    <p>メールに記載されているURLから、パスワードの再設定を行ってください。</p>
    <Button :small="isSP" primary @click="onSubmit">ログイン画面へ</Button>
  </LoginLayout>
</template>

<script>
import { mapState } from 'vuex'
import LoginLayout from '@/components/templates/LoginLayout'
import Button from '@/components/atoms/Button'

export default {
  name: 'Complete',
  components: {
    LoginLayout,
    Button,
  },
  computed: {
    ...mapState({
      isSP: state => state.app.isSP,
    }),
  },
  methods: {
    onSubmit() {
      window.location.href = this.isSP ? '/sp/login' : '/login/open/'
    },
  },
}
</script>

<style lang="postcss" scoped>
.title {
  font-size: 21px;
  font-weight: 600;
  line-height: 24px;
  margin-bottom: 48px;
  text-align: center;
}

.responsive {
  @media screen and (max-width: 559px) {
    .title {
      font-size: 16px;
      margin-bottom: 36px;
    }
  }
}
</style>
